import React from 'react';
import EditorRedo from '@wix/da-ds/pkg/Icons/24x24/EditorRedo';
import { ButtonProps } from './types';
import { isExtensionInstalled } from '../../utils/tiptap';
import { useTranslation } from 'react-i18next';
import EditorIconButton from '../_partials/EditorIconButton';
import { isTouch } from '../../utils/browser';

const Redo: React.FC<ButtonProps> = ({ editor, hideWhenNotEnabled = true }) => {
  const { t } = useTranslation('editor');
  if (
    !editor.isEditable ||
    (hideWhenNotEnabled && !isExtensionInstalled(editor, 'history'))
  ) {
    return null;
  }

  if (isTouch() && !editor.can().chain().focus().redo().run()) {
    return null;
  }

  return (
    <EditorIconButton
      featureId="action:redo"
      icon={EditorRedo}
      onClick={() => editor.chain().focus().redo().run()}
      tooltipText={t('button.redo.tooltip')}
      aria-label={t('button.redo.tooltip')}
    />
  );
};
Redo.displayName = 'Redo';

export default Redo;
